import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import "../assets/storeDashboard/dashboard.css";
import { getLocalAdminSelectedStore, getStoreLocalData, getUserData, removeLocalAdminSelectedStore, setLocalAdminSelectedStore } from "../utils/localStorage";
import { getStoreOrderDashboard, getStoreOrderDashboardAdmin } from "../services/DashboardAPI/DashboardApi";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate } from "../constants/DateUtil/DateUtil";
import { useNavigate } from "react-router-dom";
import AddNewCustomer from "./AddNewCustomer/AddNewCustomer";
import StoreMenu from "./StoreMenu";
import TabMenu from "./TabMenu";
import { getBrandStore } from "../services/StoreUsers/PostStoreUsers";
import AdminMenu from "./AdminMenu";
import SelectStoreInAdmin from "./SelectStoreInAdmin";
import { SubscriptionExpiryAlert } from "./ExpiredSoon";
import SupportAdminMenu from "./SupportAdminMenu";
import FinanceAdminMenu from "./FinanceAdminMenu";
import FinanceTabMenu from "./FinanceTabMenu";

const { innerWidth: width, innerHeight: height } = window;

const backgroundImages = [
    "/Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Pickup.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Today_bookings.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Reprocess.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Rider_delivery.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Pending_orders.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Rider_pickup.png",
    "/Laundy_App_Icons_Gifs/Home_Page/darkGreen.png",
    "/Laundy_App_Icons_Gifs/Home_Page/blue.png",
    "/Laundy_App_Icons_Gifs/Home_Page/brown.png",
    "/Laundy_App_Icons_Gifs/Home_Page/grey.png",
    "/Laundy_App_Icons_Gifs/Home_Page/orange.png",
    "/Laundy_App_Icons_Gifs/Home_Page/pink.png",
    "/Laundy_App_Icons_Gifs/Home_Page/wine.png",
    "/Laundy_App_Icons_Gifs/Home_Page/seaGreen.png",
];

const FinanceAdminDashboard = () => {
    const navigate = useNavigate();

    const { userProfileData, brandProfileData, userProfileRole } = getUserData();
    const { storeLocalData } = getStoreLocalData();
    let brandId = brandProfileData.id;
    let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff ? 0 : 2;

    const userRole = userProfileRole;
    const subscriptionExpiryDate = userProfileData.nextRenewalOn;

    const base64String = `data:image/png;base64,${brandProfileData.logo}`;

    const [searchStoreModalMenuVisible, setSearchStoreModalMenuVisible] =
        useState(false);

    const [dashboardData, setDashboardData] = useState([]);
    const [visible, setVisible] = useState(false);

    let initialStartDate = new Date();
    initialStartDate.setDate(initialStartDate.getDate() - 7); // subtract 7 days to current date

    const [storeNameData, setStoreNameData] = useState('');
    const [storeIdData, setStoreIdData] = useState("");

    const fetchStoreOrderDashboard = data => {
        getStoreOrderDashboardAdmin(brandId, data)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    const arrayResult = [
                        {
                            id: 0,
                            name: 'BOOKING',
                            orderCount: Res['BOOKING'].orderCount,
                            revenue: Number(Res['BOOKING'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['BOOKING'].storeOrderByStatus,
                            backgroundImages: backgroundImages[0],
                        },
                        {
                            id: 1,
                            name: 'REVENUE',
                            orderCount: Res['REVENUE'].orderCount,
                            revenue: Number(Res['REVENUE'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['REVENUE'].storeOrderByStatus,
                            backgroundImages: backgroundImages[1],
                        },
                        {
                            id: 2,
                            name: 'CANCEL',
                            orderCount: Res['CANCEL'].orderCount,
                            revenue: Number(Res['CANCEL'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['CANCEL'].storeOrderByStatus,
                            backgroundImages: backgroundImages[2],
                        },
                        {
                            id: 3,
                            name: 'DELIVERY',
                            orderCount: Res['DELIVERY'].orderCount,
                            revenue: Number(Res['DELIVERY'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['DELIVERY'].storeOrderByStatus,
                            backgroundImages: backgroundImages[3],
                        },
                        {
                            id: 4,
                            name: 'PENDING',
                            orderCount: Res['PENDING'].orderCount,
                            revenue: Number(Res['PENDING'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['PENDING'].storeOrderByStatus,
                            backgroundImages: backgroundImages[4],
                        },
                        {
                            id: 5,
                            name: 'PENDING_DELIVERY',
                            orderCount: Res['PENDING_DELIVERY'].orderCount,
                            revenue: Number(Res['PENDING_DELIVERY'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['PENDING_DELIVERY'].storeOrderByStatus,
                            backgroundImages: backgroundImages[5],
                        },
                        {
                            id: 6,
                            name: 'RIDER_PICKUP',
                            orderCount: Res['RIDER_PICKUP'].orderCount,
                            revenue: Number(Res['RIDER_PICKUP'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['RIDER_PICKUP'].storeOrderByStatus,
                            backgroundImages: backgroundImages[6],
                        },
                        {
                            id: 7,
                            name: 'RIDER_DELIVERY',
                            orderCount: Res['RIDER_DELIVERY'].orderCount,
                            revenue: Number(Res['RIDER_DELIVERY'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['RIDER_DELIVERY'].storeOrderByStatus,
                            backgroundImages: backgroundImages[11],
                        },
                        {
                            id: 8,
                            name: 'PAYMENT_COLLECTION',
                            orderCount: Res['PAYMENT_COLLECTION'].orderCount,
                            revenue: Number(Res['PAYMENT_COLLECTION'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus: Res['PAYMENT_COLLECTION'].storeOrderByStatus,
                            backgroundImages: backgroundImages[12],
                        },
                        {
                            id: 9,
                            name: 'STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION',
                            orderCount:
                                Res['STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION'].orderCount,
                            revenue: Number(Res['STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                            storeOrderByStatus:
                                Res['STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION']
                                    .storeOrderByStatus,
                            backgroundImages: backgroundImages[13],
                        },
                        ...(Res['REFUND'] && Res['REFUND'].revenue > 0
                            ? [
                                {
                                    id: 10,
                                    name: 'REFUND',
                                    orderCount: Res['REFUND'].orderCount,
                                    revenue: Number(Res['REFUND'].revenue)?.toFixed(enabledAmountRoundOffAdmin),
                                    storeOrderByStatus: Res['REFUND'].storeOrderByStatus,
                                    backgroundImages: backgroundImages[14],
                                },
                            ]
                            : []),
                    ];
                    setDashboardData(arrayResult);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    };

    // ✅ Fetch All or Specific Store(s)
    const fetchBrandStoreInfo = async (storeId) => {
        try {
            const response = await getBrandStore(brandId);
            if (!response.data.error) {
                const stores = response.data || [];
                const storeIds = storeId ? [storeId] : stores.map((item) => item.id);

                const data = {
                    storeIds,
                    statusIn: [],
                    startDate: localeDateStartDate(new Date(new Date())),
                    endDate: localeDateEndDate(new Date(new Date())),
                    pendingStartDate: initialStartDate,
                    localeDTO: storeLocalData
                };

                fetchStoreOrderDashboard(data);
            }
        } catch (err) {
            console.error("Error fetching store info:", err);
        }
    };

    const receiveDataFromSearchStoreModal = ({ storeInfo }) => {
        if (!storeInfo) return;

        setLocalAdminSelectedStore(storeInfo);
        setStoreNameData(storeInfo.storeName);
        setStoreIdData(storeInfo.id);
        fetchBrandStoreInfo(storeInfo.id);
    };

    // ✅ Fetch store from localStorage if available
    const fetchLocalAdminSelectedStore = () => {
        const { adminSelectedStore } = getLocalAdminSelectedStore();
        if (adminSelectedStore && Object.keys(adminSelectedStore).length > 0) {
            setStoreNameData(adminSelectedStore.storeName);
            setStoreIdData(adminSelectedStore.id);
            fetchBrandStoreInfo(adminSelectedStore.id);
            return true;
        }
        return false;
    };

    // ✅ Auto-run logic on mount
    useEffect(() => {
        const hasLocalStore = fetchLocalAdminSelectedStore();
        if (!hasLocalStore) {
            // If no store selected → fetch all
            fetchBrandStoreInfo();
        }
    }, []);

    const refreshDashboard = ({ success }) => {
        if (success) {
            fetchBrandStoreInfo();
            removeLocalAdminSelectedStore(); // or localStorage.removeItem("adminSelectedStore")
            setStoreNameData(null);
            setStoreIdData(null);
        }
    };

    const onSelectCardItem = (id, storeOrderByStatus) => {
        if (id === 0 || id === 1 || id === 2 || id === 3 || id === 4 || id === 5) {
            navigate("/DashboardOrder", {
                state: {
                    orderFilterData: storeOrderByStatus,
                    source: "s2",
                },
            });
        } else if (id === 6) {
            navigate("/AdminDashboardPickupJob", {
                state: {
                    orderFilterData: storeOrderByStatus,
                    source: "s2",
                },
            });
        } else if (id === 7) {
            navigate("/AdminDashboardDeliveryJob", {
                state: {
                    orderFilterData: storeOrderByStatus,
                    source: "s2",
                },
            });
        } else if (id === 8) {
            navigate("/DashboardPaymentCollection", {
                state: {
                    orderFilterData: storeOrderByStatus,
                    source: "s2",
                },
            });
        } else if (id === 9) {
            navigate("/WalletCollection", {
                state: {
                    orderFilterData: storeOrderByStatus,
                    source: "s2",
                },
            });
        } else if (id === 10) {
            navigate("/DashboardPaymentRefund", {
                state: {
                    orderFilterData: storeOrderByStatus,
                    source: "s2",
                },
            });
        } else {
            navigate("/Home");
        }
    };

    const renderDashboardCards = () => {
        return dashboardData.map((item) => {
            const {
                id,
                name,
                orderCount,
                revenue,
                storeOrderByStatus,
                backgroundImages,
            } = item;

            let convertedName = name;
            let displayOrderCount = orderCount;
            let icon = "";
            let todayDate = "";

            switch (name) {
                case "BOOKING":
                    convertedName = "Booking";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "REVENUE":
                    convertedName = "Revenue";
                    displayOrderCount = revenue;
                    icon = storeLocalData?.currencySymbol + " ";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "CANCEL":
                    convertedName = "Cancel";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "DELIVERY":
                    convertedName = "Delivery";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "PENDING":
                    convertedName = "Pending Orders";
                    todayDate = "Last 7 Days"
                    break;
                case "PENDING_DELIVERY":
                    convertedName = "Delay Delivery";
                    todayDate = "Last 7 Days"
                    break;
                case "RIDER_PICKUP":
                    convertedName = "Rider Pickup";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "RIDER_DELIVERY":
                    convertedName = "Rider Delivery";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "PAYMENT_COLLECTION":
                    convertedName = "Collection";
                    displayOrderCount = revenue;
                    icon = storeLocalData?.currencySymbol + " ";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION":
                    convertedName = "Wallet Collection";
                    displayOrderCount = revenue;
                    icon = storeLocalData?.currencySymbol + " ";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                case "REFUND":
                    convertedName = "Refund";
                    displayOrderCount = revenue;
                    icon = storeLocalData?.currencySymbol + " ";
                    todayDate = formatDateNew(storeOrderByStatus.startDate);
                    break;
                default:
                    break;
            }

            return (
                <div
                    key={name}
                    className="relative overflow-hidden"
                // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
                // style={{ cursor: "pointer" }}
                >
                    <img
                        className="h-8rem w-11rem"
                        src={backgroundImages}
                        alt={convertedName}
                    />
                    <div
                        className="absolute py-2 pl-3 border-round-xs"
                        style={{
                            top: "1%",
                        }}
                    >
                        <p className="text-white text-3xl font-bold uppercase">
                            {icon}
                            {displayOrderCount}
                        </p>
                        <p className="text-white text-base font-bold uppercase">
                            {convertedName}
                        </p>
                        {todayDate && (
                            <p className="text-white text-base font-bold uppercase">
                                {todayDate}
                            </p>
                        )}
                    </div>
                </div>
            );
        });
    };

    return (
        <div className="flex-1">
            <div
                className="h-8rem border-round-bottom surface-0 sticky z-1 top-0"
                style={{
                    "--border-radius": "50px",
                    "--surface-0": "#1752AA",
                }}
            >
                <div className="flex-1 flex flex-row ml-3 mr-3 pt-2">
                    <div className="flex-1 flex flex-row">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div
                                className="h-4rem w-4rem border-circle bg-white flex justify-content-center align-items-center cursor-pointer"
                                onClick={() => navigate("/UserProfile")}
                            >
                                {brandProfileData.logo ? (
                                    <img
                                        style={{ width: "35px" }}
                                        src={base64String}
                                        alt="logo"
                                    />
                                ) : (
                                    <img
                                        style={{ width: "35px" }}
                                        src="/warehouse/entrepreneur.png"
                                        alt="logo"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="flex-1 ml-3">
                            <p className="text-white text-xl font-bold uppercase">
                                {userProfileData.firstName.replace(/_/g, " ")}{" "}
                                {userProfileData.lastName.replace(/_/g, " ")}
                            </p>
                            <p className="text-white text-base font-bold uppercase">
                                {userRole === "BY_ADMIN" ? "ADMIN" : "SUB ADMIN"} -{" "}
                                {brandProfileData.name.replace(/_/g, " ")}
                            </p>
                            <p className="text-white text-sm font-light">
                                <img
                                    style={{ width: "10px", marginRight: 5 }}
                                    src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Location.png"
                                    alt="logo"
                                />
                                {brandProfileData.address.addressLine1 +
                                    " " +
                                    brandProfileData.address.addressLine2 +
                                    " " +
                                    brandProfileData.address.city +
                                    " " +
                                    brandProfileData.address.state}
                            </p>
                        </div>
                    </div>
                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => setVisible(true)}
                    >
                        <i
                            className="pi pi-bars"
                            style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
                        ></i>
                    </div>
                </div>
                <div className="flex-1 flex flex-row">
                    <div
                        className="flex-1 flex justify-content-start align-items-center relative mt-3 mx-5 h-3rem bg-white border-round-xl shadow-4"
                    // onClick={() => setSearchStoreModalMenuVisible(true)}
                    // style={{ cursor: "pointer" }}
                    >
                        <img
                            style={{ width: "20px", marginLeft: 10, marginRight: 10 }}
                            src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Search.png"
                            alt="logo"
                        />
                        <p
                            style={{
                                color: "#75879B",
                                fontSize: 16,
                            }}
                        >
                            All Store
                        </p>
                    </div>
                </div>
            </div>
            <div className="flex" style={{ marginBottom: 100 }}>
                <div className="px-0 ml-5 mr-5 relative flex-1 mt-5">
                    <div className="formgroup-inline gap-4">{renderDashboardCards()}</div>
                </div>
            </div>
            <SelectStoreInAdmin
                setSearchStoreModalMenuVisible={setSearchStoreModalMenuVisible}
                searchStoreModalMenuVisible={searchStoreModalMenuVisible}
                sendDataToAdminDashboard={receiveDataFromSearchStoreModal}
                refreshDashboard={refreshDashboard}
                brandId={brandId}
            />
            <FinanceTabMenu />
            <div>
                <SubscriptionExpiryAlert expiryDate={subscriptionExpiryDate} />

                <FinanceAdminMenu setVisible={setVisible} visible={visible} />
            </div>
        </div>
    );
};

export default FinanceAdminDashboard;


// import { Button } from 'primereact/button';
// import React from 'react'
// import { useLocation, useNavigate } from 'react-router-dom';

// const AdminDashboard = () => {
//   const navigate = useNavigate();
//   const handleBackButton = () => {
//     navigate('/logout');
//   }
//   return (
//     <div className='flex flex-1 justify-content-center '>
//       <div className='flex flex-column justify-content-center align-items-center'>
//         <img
//           src={'VectorsLaundryApp/DhobiCart.png'}
//           style={{
//             width:   400,

//           }}
//         />
//         <p className='text-3xl font-medium'>Admin Feature is Coming Soon</p>
//         <p className='text-3xl font-medium'>Please User Store Only</p>
//         <Button
//                   className="mt-3 mb-3 mx-4 border-round-xl flex-1 "
//                   onClick={handleBackButton}
//                 >
//                   <p className=" w-full text-2xl font-semibold flex justify-content-center">
//                     Back To Dhobi cart
//                   </p>
//                 </Button>
//       </div>
//     </div>
//   )
// }

// export default AdminDashboard
